
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {ItemArrayManagerTableHeader} from "@/interface/TableHeader";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import CekAlacakFormWizard from "@/components/forms/form-wizard/alacak/CekAlacakFormWizard.vue";
import {TakipTipi} from "@/enum/TakipTipi";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import BorcluVekiliForm from "@/components/forms/BorcluVekiliForm.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import { takipteBsmvAlaniniGoster, takipteKdvAlaniniGoster } from "@/helpers/TakipTipiEskiNoHelper";

@Component({
  components: {
    DeleteDialog,
    FormDialog, BorcluVekiliForm,
    ProtestoIhtarForm,
    DovizTakipSekliPicker,
    Kur,
    AyEkleForm,
    AsilAlacakKalemiForm,
    CekAlacakFormWizard,
    ItemArrayManager,
    ParaBirimiPicker,
    Tutar,
    Dates,
  },
})
export default class CekAlacakForm extends Mixins(ObjectInputMixin) {
  @Prop() takipTipiId!: number;
  @Prop({required: false}) takipTipiEskiNo?: string | number;
  @Prop() errorAlacakKalemleri!: boolean;
  @Prop({default: () => {}}) alacakDetay !: any;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Ref('alacakKalemiForm') readonly alacakKalemiForm!: AsilAlacakKalemiForm;
  @Prop({default: () => []}) alacakKalemleri!: any
  @Prop({default: () => []}) ihtarlar!: any
  @Prop({default: () => []}) protestolar!: any
  isWizardComplete: boolean = false;
  TakipTipi = TakipTipi;
  get bsmvAlaniniGoster(): boolean {
    return takipteBsmvAlaniniGoster(this.takipTipiEskiNo);
  }
  get kdvAlaniniGoster(): boolean {
    return takipteKdvAlaniniGoster(this.takipTipiEskiNo);
  }
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  alacakKalemiAlani = AlacakKalemiAlani;
  alacakKalemiDetayData: any = {}

  headers = [
    {text: 'Alacak Kalemi Türü', value: 'alacak_kalemi_alani'},
    {text: 'Açıklama', value: 'aciklama'},
    {text: 'Faiz B. Tarihi', value: 'faiz_baslangic_tarihi'},
    {text: 'Takip Öncesi Faiz', value: 'takip_oncesi_faiz_turu'},
    {text: 'Takip Sonrası Faiz', value: 'takip_sonrasi_faiz_turu'},
    {text: 'Tutar', value: 'tutar'},
    {text: 'İşlemler', value: 'actions'},
  ]
  ihtarHeaders = [
    {text: 'Tarih', value: 'tarih'},
    {text: 'Tutar', value: 'tutar'},
    {text: 'Noter', value: 'noter'},
    {text: 'İşlemler', value: 'actions'},
  ]
  faizTurleri:any[] =  [];
  paraBirimleri:any[] =  []

  async getParaBirimleri(){
    let response = await this.$helper.requestWithCache("/api/v1/para-birimi-picker");
    this.paraBirimleri = response.data;
  }

  async getFaizTurleri(){
    let response = await this.$helper.requestWithCache("/api/v1/faiz-turu/?takibe_ozel_mi=false");
    this.faizTurleri = response.data;
  }
  getTakipOncesiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_oncesi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  getTakipSonrasiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_sonrasi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  cekSeriRules =[
    (value: any) => {
      return (!!value) || "Lütfen bu alanı doldurun."
    },
    (value: any) => {
      const isValid = /^[0-9]+$/.test(value);
      return (isValid) || "Lütfen sadece rakam girin.";
    },
  ]
  get takipStore() {
    return this.$helper.getTakipStoreName(this.$route.path);
  }

  get takipBilgileri() {
    return this.$helper.getTakipBilgileri(this.$store.state, this.takipStore);
  }

  get defaultFormValues() {
    return this.$helper.getDefaultFormValues(this.takipBilgileri);
  }

  getParaBirimiSembol(paraBirimiId: number){
    const paraBirimi:any = this.paraBirimleri.find((p:any) => p.id === paraBirimiId);
    return paraBirimi ? paraBirimi.kisa_isim : '';
  }
  onAdd() {
    if (this.localValue.id) {
      this.$emit('addAlacakKalemi')
    }
  }

  onAddIhtar(){
    if (this.localValue.id){
      this.$emit('addIhtar')
    }
  }
  onAddProtesto(){
    if (this.localValue.id){
      this.$emit('addProtesto')
    }
  }

  addAsilAlacak(item: any) {
    if (!this.localValue.id) {
      this.localValue.asil_alacaklar.push(item)
    }else{
      this.onAdd()
    }
  }

  updateAsilAlacak(updatedItem: any, index: number) {
    if (this.localValue.id) {
      this.$emit('addAlacakKalemi');
    } else {
      this.$set(this.localValue.asil_alacaklar, index, updatedItem);
      this.input();
    }
  }

  updateIhtar(updatedItem: any, index: number) {
    if (!this.localValue.id) {
      this.$set(this.localValue.ihtarlar, index, updatedItem);
      this.input();
    }else{
      this.onAddIhtar()
    }
  }

  updateProtesto(updatedItem: any, index: number) {
    if (!this.localValue.id) {
      this.$set(this.localValue.protestolar, index, updatedItem);
      this.input();
    }else{
      this.onAddProtesto()
    }
  }

  addIhtar(item: any) {
    if (!this.localValue.id) {
      this.localValue.ihtarlar.push(item)
    }
  }

  addProtesto(item: any) {
    if (!this.localValue.id) {
      this.localValue.protestolar.push(item)
    }
  }

  alacakKalemiDetay(id: any) {
    if (this.localValue.id) {
      this.$http.get('/api/v1/alacak-kalemi/' + id).then((response) => {
        this.alacakKalemiDetayData = response.data;
      })
    }

  }

  deleteAsilAlacak(index: number ){
    if (this.localValue.id){
      this.$emit('delete')
    }else{
      this.localValue.asil_alacaklar.splice(index, 1);
    }
  }
  deleteIhtar(index: number) {
    if (this.localValue.id){
      this.$emit('deleteIhtar')
    }else{
      this.localValue.ihtarlar.splice(index, 1);
    }
  }
  deleteProtesto(index: number) {
    if (this.localValue.id){
      this.$emit('deleteProtesto')
    }else{
      this.localValue.protestolar.splice(index, 1);
    }
  }


  get ihtarTuru(): string {
    if (this.takipTipiId && this.takipTipiId === TakipTipi.kambiyoSenetleriyleIflas || this.takipTipiId === TakipTipi.kambiyoSenetleriyleHaciz) {
      return "protesto";
    }
    return "ihtar";
  }

  get aciklama() {
    if (this.localValue.cek_seri_no && this.localValue.para_birimi_id) {
      let kesideTarihi = this.$helper.tarihStr(this.localValue.keside_tarihi ?? "");
      return kesideTarihi + " günlü " + this.localValue.cek_seri_no + " Seri No lu çek, " + this.$helper.tutarStr(this.localValue.tutar, this.localValue.para_birimi);
    }
  }

  @Watch("aciklama")
  onAciklamaChange() {
    if(!this.localValue.id){
      this.localValue.aciklama = this.aciklama;
    }
  }

  @Watch('localValue.doviz_kur_tarihi')
  onDovizTakipSekliChange() {
    this.addParaBirimi();

    // asil_alacaklar kontrolü ekleyin
    if (this.localValue?.asil_alacaklar && Array.isArray(this.localValue.asil_alacaklar)) {
      this.localValue.asil_alacaklar.forEach((asilAlacak: AlacakKalemiEntity) => {
        if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.vade) {
          asilAlacak.para_birimi_id = this.paraBirimi.TRY;
          asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
        } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
          asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
          asilAlacak.para_birimi = this.localValue.para_birimi;
        }
      });
    }

    this.input();
  }

  @Watch('localValue.para_birimi_id')
  onParaBirimiIdChange() {
    this.addParaBirimi();
  }

  @Watch('localValue')
  onLocalValueChange() {
    if (!this.localValue.takip_tarihli_kurlar) {
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      delete this.localValue.doviz_kur_tarihi;

      // asil_alacaklar kontrolü ekleyin
      if (this.localValue.asil_alacaklar && Array.isArray(this.localValue.asil_alacaklar)) {
        this.localValue.asil_alacaklar.forEach((asilAlacak: AlacakKalemiEntity) => {
          asilAlacak.para_birimi_id = this.paraBirimi.TRY;
          asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
        });
      }
    } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {

      // asil_alacaklar kontrolü ekleyin
      if (this.localValue.asil_alacaklar && Array.isArray(this.localValue.asil_alacaklar)) {
        this.localValue.asil_alacaklar.forEach((asilAlacak: AlacakKalemiEntity) => {
          asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
          asilAlacak.para_birimi = this.localValue.para_birimi;
        });
      }
    }
    this.addParaBirimi();
    this.input();
  }

  mounted() {
    this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    this.getFaizTurleri();
    this.getParaBirimleri()
    this.input();
  }

  load() {

  }

  loadAlacakKalemleri(){
    this.$emit('addAlacakKalemi')

  }
  addParaBirimi() {
    if (this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur: any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      let kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }
}
